Solver.wishlist.ui = function (items) {
	if (!items) return;

	const container = document.querySelector('[data-wishlist-count]');

	if (!container) return;

	if (items.length > 0) container.innerText = items.length;
	if (items.length <= 0) container.innerText = '';
};

Solver.wishlist.get = function () {
	const storage = window.localStorage.getItem('wishlist');

	if (!storage) return null;

	return JSON.parse(storage);
};

Solver.wishlist.getItem = function (productId) {
	let storage = window.localStorage.getItem('wishlist');

	if (!storage) return false;

	storage = JSON.parse(storage);

	const productExists = storage.findIndex((id) => id == productId);

	if (productExists == -1) return false;

	return true;
};

Solver.wishlist.set = function () {
	window.localStorage.setItem('wishlist', JSON.stringify([]));

	return [];
};

Solver.wishlist.setItem = function (productId) {
	if (!productId) return;

	const storage = Solver.wishlist.get();
	const productExists = storage.findIndex((id) => id == productId);

	if (productExists > -1) return null;

	storage.push(productId);

	window.localStorage.setItem('wishlist', JSON.stringify(storage));

	return storage;
};

Solver.wishlist.removeItem = function (productId) {
	if (!productId) return;

	let storage = Solver.wishlist.get();
	storage = storage.filter((id) => id != productId);

	window.localStorage.setItem('wishlist', JSON.stringify(storage));

	return storage;
};
